module.exports = __webpack_public_path__ + "img/fire1.0a9d92f2.svg";